<modal>
  <span header class="uppercase">{{title}}</span>

  <table class="data">
    <tr>
      <td class="text-left">
        <div class="uppercase bold small">{{(subject == 'service' ? 'Dịch vụ' : 'Đối tác') | lang}}</div>
        <span class="bold uppercase nowrap">{{partner.Name}}</span>
      </td>
      <td class="text-right">
        <div class="uppercase bold small">{{'Địa chỉ' | lang}}</div>
        <span class="uppercase nowrap">{{partner.Address}}</span>
      </td>
    </tr>
    <tr>
      <td>
        <div class="uppercase bold small">{{(type == 'income' ? 'thu' : 'chi') + ' ngày' | lang}}</div>
        <span class="bold nowrap">{{payment.Stamp | date : 'dd-MM-yyyy'}}</span>
      </td>
      <td class="nowrap text-right">
        <div class="uppercase bold small">{{'Số tiền' | lang}}</div>
        <span class="bold" [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}">{{(type == 'expense' ? payment.SendAmount : payment.ReceiveAmount) | number : '1.0-1' : 'en-US'}}</span>
        <vnd *ngIf="(type == 'expense' ? payment.SendSymbol : payment.ReceiveSymbol) == 'VND'"></vnd>
        <cny *ngIf="(type == 'expense' ? payment.SendSymbol : payment.ReceiveSymbol) == 'CNY'"></cny>                
      </td>
    </tr>
    <tr *ngIf="payment.SendSymbol != payment.ReceiveSymbol">
      <td>
        <div class="uppercase bold small">{{'Tỷ giá' | lang}}</div>
        <span class="bold hlf-margin-left">{{payment.SendAmount / payment.ReceiveAmount | number : '1.0-0' : 'en-US'}}</span><vnd-per-cny></vnd-per-cny>
      </td>
      <td class="text-right">
        <div class="uppercase bold small">{{'Quy đổi thành' | lang}}</div>
          <span [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}">{{(type == 'income' ? payment.SendAmount : payment.ReceiveAmount) | number : '1.0-1' : 'en-US'}}</span>
          <vnd *ngIf="(type == 'income' ? payment.SendSymbol : payment.ReceiveSymbol) == 'VND'"></vnd>
          <cny *ngIf="(type == 'income' ? payment.SendSymbol : payment.ReceiveSymbol) == 'CNY'"></cny>
      </td>
    </tr>
    <tr *ngIf="payment.Notes.length > 0">
      <td [colSpan]="2" class="text-left">
        <div class="uppercase bold small">{{'Nội dung' | lang}}</div>
        {{payment.Notes}}
      </td>
    </tr>
  </table>

  <collapsible *ngIf="reasons.length > 0">
    <div header class="uppercase">{{'Các khoản được thanh toán' | lang}}</div>
    <table responsive class="data">
      <tr>
        <th class="text-top">{{'Ngày' | lang}}</th>
        <th class="text-top">{{'Khoản đối trừ' | lang}}</th>
        <th class="text-top text-right">{{'Số tiền' | lang}}</th>
      </tr>
      <tr *ngFor="let i of reasons">
        <td>
          <span class="bold nowrap">{{i.Stamp | date : 'dd-MM-yyyy'}}</span></td>
        <td class="bold text-primary nowrap">{{i.Tag}}</td>
        <td class="nowrap">
          <span [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}">{{i.Amount | number : '1.0-1' : 'en-US'}}</span>
          <vnd *ngIf="payment.ReceiveSymbol == 'VND'"></vnd>
          <cny *ngIf="payment.ReceiveSymbol == 'CNY'"></cny>
        </td>
      </tr>
      <tr class="footer bold" *ngIf="reasons.length > 1">
        <td>{{'TỔNG' | lang}}</td>
        <td></td>
        <td>
          <span [ngClass]="{'text-danger': type == 'expense', 'text-success': type == 'income'}">{{used | number : '1.0-1' : 'en-US'}}</span>
          <vnd *ngIf="payment.ReceiveSymbol == 'VND'"></vnd>
          <cny *ngIf="payment.ReceiveSymbol == 'CNY'"></cny>
        </td>
      </tr>
      <tr class="bold">
        <td class="text-primary">{{'CHƯA ĐỐI TRỪ' | lang}}</td>
        <td></td>
        <td>
          <span class="text-primary">{{left | number : '1.0-1' : 'en-US'}}</span>
          <vnd *ngIf="payment.ReceiveSymbol == 'VND'"></vnd>
          <cny *ngIf="payment.ReceiveSymbol == 'CNY'"></cny>
        </td>
      </tr>
    </table>
  </collapsible>

  <button class="text-white bg-danger std-margin-top w-100" *ngIf="deletable" (click)="delete()"><i class="fa fa-times"></i><span>Xóa phiếu {{type == 'income' ? 'thu' : 'chi'}}</span></button>

</modal>
